// BrowserProbe client test engine — public surface (exposed on window.BrowserProbe).
//
// The permissionless core probes self-register into the default registry on load (BP-013).
// Business/Premium probes follow in BP-014.

import { registry } from './registry';
import { registerCoreProbes } from './probes/core';
import { registerBusinessProbes } from './probes/business';

export * from './types';
export { ProbeRegistry, registry, runProbe, runAll } from './registry';
export type { EngineConfig } from './registry';
export { scoreByThresholds } from './scoring';
export type { ProbeResultType } from './scoring';
export {
  buildResultsPayload,
  postResults,
  toResultDto,
  IngestionError,
} from './results';
export type {
  ProbeResultDto,
  RunResultsPayload,
  IngestionResponse,
  PostResultsOptions,
  BuildPayloadOptions,
} from './results';
export { coreProbes, registerCoreProbes } from './probes/core';
export { businessProbes, registerBusinessProbes } from './probes/business';
export {
  readBrowserEnvironment,
  selectClosestNode,
  createNetContext,
  createBrowserCapabilities,
  createRtcContext,
  createMediaContext,
  createStorageContext,
  createPermissionsContext,
  createFingerprintContext,
  createBlockerContext,
  createDeviceContext,
  createReachabilityContext,
  createEntropyContext,
  createIspContext,
  createIpContext,
} from './environment';

// Register the built-in probes into the default registry. Permissioned probes are gated at
// selection time (EngineConfig.includePermissioned), so registering them is safe.
registerCoreProbes(registry);
registerBusinessProbes(registry);

declare const __ENGINE_VERSION__: string;

/** Engine bundle version, injected at build time from package.json. */
export const version: string = __ENGINE_VERSION__;
